import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Line } from 'vue-chartjs';
import {
  lineChartColors,
  LineChartDatasetInterface,
  TotalDailyStatisticInterface,
} from '@/services/QA/statistics/interfaces';

@Component({})
export default class MainDailyLineChart extends Mixins(Line) {
  @Prop() public title!: string;
  @Prop() public data!: TotalDailyStatisticInterface[];
  private dataSets: LineChartDatasetInterface[] = [];
  private color: IterableIterator<string> = lineChartColors[Symbol.iterator]();

  public mounted(): void {
    if (!this.data.length) {
      return;
    }
    Object.keys(this.data[0]).forEach((key) => {
      if (key === 'date') {
        return;
      }
      const set: LineChartDatasetInterface = {
        label: key,
        data: this.data.map((data) => {
          // @ts-ignore
          return data[key];
        }),
        borderColor: this.color.next().value,
        fill: false,
        tension: 0.1,
      };
      this.dataSets.push(set);
    });

    this.createChart();
  }

  public update(labels: string[], values: number[]): void {
    this.createChart();
  }

  private createChart(): void {
    this.renderChart({
      labels: this.data.map((d) => new Date(d.date).toLocaleString('en-gb').substr(0, 10))
        .filter((label, index, array) => array.indexOf(label) === index),
      datasets: this.dataSets,
    }, {
      title: {
        text: this.title,
        display: true,
      },
      onClick: (evt, x: any[]) => {
        if (!x || !x[0]) {
          return;
        }
        const index = x[0]._index;
        const date = this.data[index].date;

        this.$emit('updateTime', date);
      },
      onHover: (event: MouseEvent, chartElement) => {
        if (event.target) {
          // @ts-ignore
          event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
        }
      },
      responsive: true,
      elements: {
        point: {
          radius: 5,
        },
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'Count',
          },
          ticks: {
            padding: 10,
            beginAtZero: true,
            callback: (value: number): number | undefined => {
              if (value % 1 === 0) {
                return value;
              }
            },
          },
        }],
      },
    });
  }
}
